import { ref } from 'vue'

const menu = ref([])

const FOOD_IMAGE_URL =
  'https://images.unsplash.com/photo-1658040529144-3c91a93c4ef0?q=80&w=1335&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'

const CAFE_DEFAULT_MENU = [
  {
    nama: "Espresso",
    kategori: "minuman",
    image: "https://images.unsplash.com/photo-1521302080334-4bebac2763a6?q=80&w=800&auto=format&fit=crop",

    harga: "Rp18.000",
    description: "Single shot espresso dengan karakter bold"
  },
  {
    nama: "Cappuccino",
    kategori: "minuman",
    image: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=80&w=800&auto=format&fit=crop",
    harga: "Rp25.000",
    description: "Espresso, susu steamed, dan foam yang lembut"
  },
  {
    nama: "Kopi Susu Gula Aren",
    kategori: "minuman",
    harga: "Rp24.000",
    image: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=80&w=800&auto=format&fit=crop",
    description: "Kopi dingin dengan susu segar dan gula aren"
  },
  {
    nama: "Matcha Latte",
    kategori: "minuman",
    image: "https://images.unsplash.com/photo-1515823662972-da6a2e4d3002?q=80&w=800&auto=format&fit=crop",
    harga: "Rp28.000",
    description: "Matcha premium dengan susu, creamy dan tidak pahit"
  },
  {
    nama: "Iced Lemon Tea",
    kategori: "minuman",
    image: "https://images.unsplash.com/photo-1551024709-8f23befc6f87?q=80&w=800&auto=format&fit=crop",
    harga: "Rp20.000",
    description: "Teh segar dengan perasan lemon dan es"
  },
  {
    nama: "Chicken Sandwich",
    kategori: "makanan",
    image: FOOD_IMAGE_URL,
    harga: "Rp35.000",
    description: "Roti panggang isi ayam, lettuce, dan saus mayo"
  },
  {
    nama: "Pasta Aglio Olio",
    kategori: "makanan",
    image: FOOD_IMAGE_URL,
    harga: "Rp42.000",
    description: "Pasta ringan dengan bawang putih, chili flakes, dan parmesan"
  },
  {
    nama: "Butter Croissant",
    kategori: "dessert",
    image: "https://images.unsplash.com/photo-1555507036-ab1f4038808a?q=80&w=800&auto=format&fit=crop",
    harga: "Rp22.000",
    description: "Croissant renyah dengan aroma butter"
  },
  {
    nama: "Chocolate Brownie",
    kategori: "dessert",
    image: "https://images.unsplash.com/photo-1606313564200-e75d5e30476c?q=80&w=800&auto=format&fit=crop",
    harga: "Rp24.000",
    description: "Brownie fudgy dengan cokelat pekat"
  },
  {
    nama: "Cheesecake Blueberry",
    kategori: "dessert",
    image: "https://images.unsplash.com/photo-1542826438-bd32f43d626f?q=80&w=800&auto=format&fit=crop",
    harga: "Rp38.000",
    description: "Cheesecake dingin dengan topping blueberry"
  }
]

const OLD_DEFAULT_MENU_NAMES = new Set([
  "Nasi Goreng Spesial",
  "Mie Ayam Bakso",
  "Ayam Bakar Madu",
  "Lemon Squash",
  "Teh Tarik Dingin",
  "Brownies Coklat",
  "Cheesecake Stroberi"
])

const CAFE_DEFAULT_MENU_NAMES = new Set(CAFE_DEFAULT_MENU.map((item) => item.nama))

const safeParseJson = (value, fallback) => {
  if (!value) return fallback
  try {
    return JSON.parse(value)
  } catch {
    return fallback
  }
}

const isLikelyOldDefaultMenu = (items) => {
  if (!Array.isArray(items)) return false
  return items.some((item) => OLD_DEFAULT_MENU_NAMES.has(item?.nama))
}

const isLikelyCafeDefaultMenu = (items) => {
  if (!Array.isArray(items)) return false
  if (items.length !== CAFE_DEFAULT_MENU.length) return false
  return items.every((item) => CAFE_DEFAULT_MENU_NAMES.has(item?.nama))
}

const saveMenuToStorage = (items) => {
  try {
    localStorage.setItem('menu', JSON.stringify(items))
  } catch {
    // ignore storage errors (private mode / quota)
  }
}

const storedMenu = safeParseJson(localStorage.getItem('menu'), null)

if (storedMenu && !isLikelyOldDefaultMenu(storedMenu) && !isLikelyCafeDefaultMenu(storedMenu)) {
  menu.value = storedMenu
} else {
  menu.value = CAFE_DEFAULT_MENU
  saveMenuToStorage(menu.value)
}

export default menu